import { EventEmitter } from "events";

import Swagger from "swagger-client";

import sessionStore from "./SessionStore";
import {checkStatus, errorHandler } from "./helpers";
import dispatcher from "../dispatcher";


class NetworkServerStore extends EventEmitter {
  constructor() {
    super();
    this.swagger = new Swagger("/swagger/networkServer.swagger.json", sessionStore.getClientOpts());
  }

  create(networkServer, callbackFunc) {
    this.swagger.then(client => {
      client.apis.NetworkServerService.NetworkServerService_Create({
        body: {
          networkServer: networkServer,
        },
      })
      .then(checkStatus)
      .then(resp => {
        this.notifiy("created");
        callbackFunc(resp.obj);
      })
      .catch(errorHandler);
    });
  }

  get(id, callbackFunc) {
    this.swagger.then((client) => {
      client.apis.NetworkServerService.NetworkServerService_Get({
        id: id,
      })
      .then(checkStatus)
      .then(resp => {
        callbackFunc(resp.obj);
      })
      .catch(errorHandler);
    });
  }

  update(networkServer, callbackFunc) {
    this.swagger.then(client => {
      client.apis.NetworkServerService.NetworkServerService_Update({
        "networkServer.id": networkServer.id,
        body: {
          networkServer: networkServer,
        },
      })
      .then(checkStatus)
      .then(resp => {
        this.notifiy("updated");
        callbackFunc(resp.obj);
      })
      .catch(errorHandler);
    });
  }

  notifiy(action) {
    dispatcher.dispatch({
      type: "CREATE_NOTIFICATION",
      notification: {
        type: "success",
        message: "network-server has been " + action,
      },
    });
  }

  delete(id, callbackFunc) {
    this.swagger.then(client => {
      client.apis.NetworkServerService.NetworkServerService_Delete({
        id: id,
      })
      .then(checkStatus)
      .then(resp => {
        this.notifiy("deleted");
        callbackFunc(resp.obj);
      })
      .catch(errorHandler);
    });
  }
  
  list(organizationID, limit, offset, callbackFunc,order,orderBy) {
    this.swagger.then((client) => {
      client.apis.NetworkServerService.NetworkServerService_List({
        organizationID: organizationID,
        limit: limit,
        offset: offset,
        order:order,
        orderBy:orderBy
      })
      .then(checkStatus)
      .then(resp => {
        callbackFunc(resp.obj);
      })
      .catch(errorHandler);
    });
  }

  getADRAlgorithms(networkServerID, callbackFunc) {
    this.swagger.then((client) => {
      client.apis.NetworkServerService.NetworkServerService_GetADRAlgorithms({
        networkServerId: networkServerID,
      })
      .then(checkStatus)
      .then(resp => {
        callbackFunc(resp.obj);
      })
      .catch(errorHandler);
    });
  }
}

const networkServerStore = new NetworkServerStore();
export default networkServerStore;
window.test = networkServerStore;
